import { renderComponent } from "./renderComponent";

export const renderNothing = renderComponent(null);

export default renderNothing;
